import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Button, Input, Modal, ModalBody } from "reactstrap";
import api from "../../../utils/api"

const GuestReview = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [successModal, setSuccessModal] = useState(false);
const [params] = useSearchParams();
  const tenant = params.get("tenant");
const orderIdFromParams = params.get("orderId");
  // ✅ SAFE ORDER ID FALLBACK
  const orderIdFromState = state?.orderId;
  const orderIdFromStorage = localStorage.getItem("lastPaidOrderId");
const orderId =
  orderIdFromState ||
  orderIdFromParams ||
  orderIdFromStorage;
  const [items, setItems] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [overallNote, setOverallNote] = useState("");
  const [loading, setLoading] = useState(true);

  console.log("TENANT FROM URL:", tenant);
console.log("ORDER ID:", orderId);

  /* ===============================
     FETCH ORDER
     =============================== */
useEffect(() => {
  if (!orderId || !tenant) {
    setLoading(false);
    return;
  }

const fetchOrder = async () => {
  try {
    const { data: order } = await api.get(
      `/guest/orders/${orderId}`,
      { params: { tenant } }
    );

    console.log("🟢 ORDER FETCHED:", order);

    const orderItems = order?.items || [];

    /* ===============================
       GROUP DUPLICATE ITEMS
       =============================== */

    const grouped = {};

    orderItems.forEach(item => {
      const id = item.menuItemId || item.menuItem?._id;

      if (!grouped[id]) {
        grouped[id] = {
          ...item,
          quantity: item.quantity || 1
        };
      } else {
        grouped[id].quantity += item.quantity || 1;
      }
    });

    const uniqueItems = Object.values(grouped);

    setItems(uniqueItems);

    /* ===============================
       PREPARE REVIEWS
       =============================== */

    const mappedReviews = uniqueItems.map(item => ({
      itemId: item.menuItemId || item.menuItem?._id,
      itemName: item.menuItem?.name || item.name,
      rating: 0,
      note: ""
    }));

    setReviews(mappedReviews);

  } catch (err) {
    console.error("❌ Fetch error:", err);
  } finally {
    setLoading(false);
  }
};

fetchOrder();
}, [orderId, tenant]);

  /* ===============================
     SUBMIT REVIEW
     =============================== */
const handleSubmit = async () => {
  const unrated = reviews.some(r => r.rating < 1);

  if (unrated) {
    alert("Please rate all items ⭐");
    return;
  }

  const payloadReviews = reviews.map(r => ({
    itemId: r.itemId || null,
    itemName: r.itemName,
    rating: r.rating,
    note: r.note || ""
  }));

  console.log("SUBMIT REVIEW PAYLOAD:", {
    orderId,
    tenant,
    overallNote,
    reviews: payloadReviews
  });

  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("guestToken");

  try {
    const { data } = await api.post(
      `/feedback`,
      {
        orderId,
        overallNote,
        reviews: payloadReviews,
        tenantId: tenant
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : ""
        }
      }
    );

    console.log("🟢 FEEDBACK SUBMITTED:", data);

    localStorage.removeItem("lastPaidOrderId");
    localStorage.removeItem("currentOrder");

    setSuccessModal(true);

  } catch (err) {
    console.error("❌ NETWORK ERROR:", err);
    alert(err?.response?.data?.message || "Server error");
  }
};
  /* ===============================
     INVALID SESSION
     =============================== */
  if (!orderId) {
    return (
      <div className="p-4 text-center">
        <h6>Review session expired</h6>
        <Button
          color="secondary"
          size="sm"
          onClick={() => navigate("/apps-bookings")}
        >
          Back to Bookings
        </Button>
      </div>
    );
  }

  if (loading) {
    return <div className="p-4 text-center">Loading order...</div>;
  }

  /* ===============================
     UI
     =============================== */
  return (
    <div style={{ background: "#f6f6f6", minHeight: "100vh" }}>
      {/* HEADER */}
      <div
        style={{
          background: "#fff",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          gap: 12,
          boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
          position: "sticky",
          top: 0,
          zIndex: 10
        }}
      >
        <i
          className="ri-arrow-left-line"
          style={{ fontSize: 22, cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h5 className="mb-0">Reviews</h5>
      </div>

      <div className="p-3">
        {items.length === 0 && (
          <div className="text-center text-muted">
            No items found for review.
          </div>
        )}

        {items.map((item, idx) => (
          <div
            key={idx}
            className="mb-4 p-3"
            style={{
              background: "#fff",
              borderRadius: 14,
              boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
            }}
          >
            {/* ITEM INFO */}
            <div className="d-flex gap-3 mb-2">
              <img
                src={item.menuItem?.image || item.image}
                alt={item.menuItem?.name || item.name}
                style={{
                  width: 70,
                  height: 70,
                  borderRadius: 12,
                  objectFit: "cover"
                }}
              />

              <div>
                <strong>{item.menuItem?.name || item.name}</strong>
                <div className="text-muted small">
                  Qty {item.quantity}
                </div>
              </div>
            </div>

            {/* ⭐ STAR RATING */}
            <div className="mb-2">
              {[1, 2, 3, 4, 5].map(star => (
                <i
                  key={star}
                  className={
                    reviews[idx]?.rating >= star
                      ? "ri-star-fill"
                      : "ri-star-line"
                  }
                  style={{
                    fontSize: 22,
                    marginRight: 6,
                    cursor: "pointer",
                    color:
                      reviews[idx]?.rating >= star ? "#ffc107" : "#ccc"
                  }}
                  onClick={() => {
                    const copy = [...reviews];
                    copy[idx].rating = star;
                    setReviews(copy);
                  }}
                />
              ))}
            </div>

            {/* NOTE */}
            <Input
              placeholder="Write a note for this item"
              value={reviews[idx]?.note || ""}
              onChange={e => {
                const copy = [...reviews];
                copy[idx].note = e.target.value;
                setReviews(copy);
              }}
            />
          </div>
        ))}

        {/* OVERALL NOTE */}
        <Input
          className="mb-3"
          placeholder="Overall experience (optional)"
          value={overallNote}
          onChange={e => setOverallNote(e.target.value)}
        />

        <Button color="success" block onClick={handleSubmit}>
          Submit Review
        </Button>
      </div>
      <Modal
  isOpen={successModal}
  centered
  backdrop="static"
>
  <ModalBody className="text-center p-4">
    <div style={{ fontSize: 50, color: "#28a745" }}>✅</div>
    <h5 className="mt-3">Thank You!</h5>
    <p className="text-muted">
      Your feedback helps us improve your experience.
    </p>

    <Button
      color="success"
      onClick={() => {
        setSuccessModal(false);
        navigate("/apps-bookings");
      }}
    >
      Back to Bookings
    </Button>
  </ModalBody>
</Modal>
    </div>
  );
};

export default GuestReview;
